export default "__VITE_ASSET__Dvo1tr15__"